// extracted by mini-css-extract-plugin
export default {"firstSection":"Podian_firstSection__cqZ8p","secondSection":"Podian_secondSection__UVgnu"};